export const EMAIL_REGEX =
    /^(?!\.)([a-zA-Z0-9!#$%&'*+\-/=?^_`{|}~]+(\.[a-zA-Z0-9!#$%&'*+\-/=?^_`{|}~]+)*)@([a-zA-Z][a-zA-Z0-9.-]*)\.[a-zA-Z]{2,}$/;

export const URL_REGEX = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w\-./?%&=]*)?$/;
export const ALPHA_NUMBER_REGEX = /^[a-zA-Z0-9]+$/;
export const FORBIDDEN_LANG_REGEX = /[ぁ-んァ-ン一-龯ăâđêôơưáéíóúýàèìòùỳảẻỉỏủỷãẽĩõũỹạẹịọụỵ]/i;
export const FORBIDDEN_SPECIAL_CHAR_REGEX = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;
export const REGEX_DATE_TIME = /^(\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2})\.\d+$/;
export const ALPHA_NUMBER_JP_REGEX = /^[a-zA-Z0-9０-９ぁ-んァ-ヶー一-龯々〆〤\-_]+$/;
export const IS_VALID_MANIFEST_ID = /^\d{11}$/;
export const IS_VALID_NUMBER = /^\d+(\.\d+)?$/;
